import { FC } from 'react';

import { FormControl, VStack } from '@bonusly/design-system';
import { FeatureFlag, useAnalytics } from '@bonusly/who-am-i';

import { Award } from '../../../../../../types/bonus';
import { AwardOption } from './AwardOption';
import { OldAwardOption } from './OldAwardOption';

type AwardSelectionListProps = {
	awards: Award[];
	group: string;
	selectAward: (award: Award) => void;
	selectedAward: Award | null;
	isTemplatedAward: boolean;
};

export const AwardSelectionList: FC<AwardSelectionListProps> = ({ awards, group, selectAward, selectedAward, isTemplatedAward }) => {
	const { track } = useAnalytics();

	const handleSelectAwardOption = (award: Award) => {
		track('Award Selection', {
			award_name: award.giver.first_name,
			award_type: isTemplatedAward ? 'Templated' : 'Non Templated',
			budget_timeframe: award.budget_period,
		});
		selectAward(award);
	};
	return (
		<FormControl>
			<VStack spacing={0}>
				{awards.map((award) => {
					return (
						<FeatureFlag
							key={award.id}
							flag="awards-redesign"
							fallback={<OldAwardOption award={award} group={group} isChecked={award === selectedAward} onClick={() => handleSelectAwardOption(award)} />}
						>
							<AwardOption award={award} isChecked={award === selectedAward} onClick={() => handleSelectAwardOption(award)} />
						</FeatureFlag>
					);

					return;
				})}
			</VStack>
		</FormControl>
	);
};
